import React from 'react';
import ModalCustomSize from './components/ModalCustomSize';
import DeleteModalContent from './ContentModal/DeleteModalContent';
import DuplicateModalContent from './ContentModal/DuplicateModalContent';
import RenameModalContent from './ContentModal/RenameModalContent';
import RestoreModalContent from './ContentModal/RestoreModalContent';
import DeletePageModalContent from './ContentModal/DeletePageModalContent';

export type ModalType = 'delete' | 'rename' | 'versionName' | 'duplicate' | 'restore' | 'delete-page';

export interface ModalProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

const ModalFactory: React.FC<{ type: ModalType; props: ModalProps }> = ({ type, props }) => {
  switch (type) {
    case 'delete':
      return (
        <ModalCustomSize modalSize='small' props={props}>
          <DeleteModalContent {...props} />
        </ModalCustomSize>
      );
    case 'rename':
      return (
        <ModalCustomSize modalSize='medium' props={props}>
          <RenameModalContent {...props} type={'document'} />
        </ModalCustomSize>
      );
    case 'versionName':
      return (
        <ModalCustomSize modalSize='medium' props={props}>
          <RenameModalContent {...props} type={'version'} />
        </ModalCustomSize>
      );
    case 'duplicate':
      return (
        <ModalCustomSize modalSize='small' props={props}>
          <DuplicateModalContent {...props} />
        </ModalCustomSize>
      );
    case 'restore':
      return (
        <ModalCustomSize modalSize='small' props={props}>
          <RestoreModalContent {...props} />
        </ModalCustomSize>
      );
    case 'delete-page':
      return (
        <ModalCustomSize modalSize='small' props={props}>
          <DeletePageModalContent {...props} />
        </ModalCustomSize>
      );
    default:
      return null;
  }
};

export default ModalFactory;
